/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const POSTBATTLE_SCREEN_HEADER_TITLES = {
    victory: (
        <FormattedMessage
            id='postbattle_screen_header_titles.victory'
            defaultMessage='Победа!'
        />
    ),
    defeat: (
        <FormattedMessage
            id='postbattle_screen_header_titles.defeat'
            defaultMessage='Поражение'
        />
    ),
    draw: (
        <FormattedMessage
            id='postbattle_screen_header_titles.draw'
            defaultMessage='Ничья'
        />
    ),
}



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/components/Header/constants.jsx